module.exports = __webpack_public_path__ + "static/img/3.e7e5984.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/sp/3.png
// module id = Px2r
// module chunks = 0